<template>
  <form id="unsubscribe" novalidate
    :action="action"
    @submit.prevent="handleSubmit"
    @submit="$v.$touch">
    <div class="form-group flex">
      <label for="unsubscribe-email">{{ gettext('Email address') }}</label>
      
      <div class="input-group">
        <input v-model="email" type="email" name="email" id="unsubscribe-email" :placeholder="gettext('example@email.com')"
          @blur="$v.email.$touch"
          :class="{error: $v.email.$error, valid: $v.email.$dirty && !$v.email.$invalid}">
        <span class="form-error" v-if="$v.email.$dirty && ( !$v.email.email || !$v.email.required )">{{ gettext('Please enter a valid email address.') }}</span>
      </div>
      
      <button class="btn btn-3d" type="submit">{{ pgettext('Submit form', 'Send') }}</button>
    </div>
    <div v-if="errors" class="form-messages">
        <p v-for="error in errors" :key="error" class="callout form-message error">
            {{ error }}
        </p>
    </div>
    <div v-if="messages" class="form-messages">
        <p v-for="message in messages" :key="message" class="callout form-message">
            {{ message }}
        </p>
    </div>
  </form>
</template>

<script>
  import axios from 'axios'
  import _ from 'lodash'
  import Cookies from 'js-cookie'
  
  import { required, email } from 'vuelidate/lib/validators'
  
  export default {
    name: 'UnsubscribeForm',
    props: {
      action: {
        type: String,
        required: true
      },
    },

    data() {
      return {
        email: '',
        rawErrors: {},
        messages: {}
      }
    },

    computed: {
      errors() {
        // return _.flatten(_.values(this.rawErrors))
        return this.rawErrors
      }
    },

    methods: {
      handleSubmit(ev) {
        if ( this.$v.$invalid ) return
        
        this.rawErrors = {}
        this.messages = {}

        let formAction = ev.target.action
        let formData = {
          email: this.email
        }

        let formHeaders = { 'X-CSRFToken': Cookies.get('csrftoken') }

        axios.post(formAction, formData, { headers: formHeaders }).then(
          (success) => { this.messages = success.data.success },
          (error) => { this.rawErrors = error.response.data.errors }
        )
        console.log(formData)
      }
    },
    
    validations: {
      email: {
        required,
        email
      }
    }
  }
</script>



// WEBPACK FOOTER //
// js/UnsubscribeForm.vue